var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-3 px-3 p-2" },
    [
      _c("b-skeleton", {
        attrs: {
          type: "input",
          animation: "fade",
          width: "80%",
          height: "0.5rem",
        },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        staticClass: "my-1",
        attrs: {
          type: "input",
          animation: "fade",
          width: "60%",
          height: "0.3rem",
        },
      }),
      _vm._v(" "),
      _c("b-skeleton", {
        attrs: {
          type: "input",
          animation: "fade",
          width: "90%",
          height: "0.1rem",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }